import { toast } from 'react-toastify';
import api from './api-instance';
import { AxiosDataReturn } from '../types/generic';
import { TDashboardStats } from '../types/dashboard';
import { AxiosRequestConfig } from 'axios';

export const getDashboardStats = async (args?: AxiosRequestConfig<any>) => {
  try {
    const res = await api.get<AxiosDataReturn<TDashboardStats>>(
      '/dashboard/admin/get-stats',
      args
    );
    return res?.data;
  } catch (e) {
    toast.error('Something went wrong', { toastId: 'api-error' });
    throw e;
  }
};
